import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import SecurityContainer from "./SecurityContainer";
export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.SECURITY],
  };
  return (
    <App
      isProtected={isProtected}
      checkRoles={checkRoles}
      showSidebar={true}
      adminHeader={true}
    >
      <SecurityContainer />
    </App>
  );
};
